import React, { useState, useEffect } from "react";

import { FiPaperclip } from "react-icons/fi";
import { PiPaperPlaneTilt } from "react-icons/pi";
import { IoMdArrowRoundBack } from "react-icons/io";

import AlignerImage from "./../assets/aligner.png";
// import ProfileImage1 from "./../assets/profile_image_1.png";
import ProfileImage2 from "./../assets/profile_image_2.png";
import {
  DESCRIPTION_COLOR,
  HEADER_COLOR,
  PRIMARY_COLOR,
  // SECONDARY_COLOR,
  TERTIARY_COLOR,
  TEXT_COLOR,
} from "../constants/theme";
import { toast } from "react-toastify";
import { getChats } from "../services/chat/chat.service";
import moment from "moment";
import { ReactComponent as UserIcon } from "./../assets/user_icon.svg";
import { getMessagesByChat } from "../services/messages/messages.service";
import { getCaseByCaseId } from "../services/case/case.service";
import Loader from "../components/Loader";

const DiscussionScreen = () => {
  const [chatView, setChatView] = useState("Both");
  const [screenWidth, setScreenWidth] = useState(0);
  const email = sessionStorage.getItem("email");
  // const clinicCode = sessionStorage.getItem("clinic")
  //   ? JSON.parse(sessionStorage.getItem("clinic"))[0]?.clinic_code
  //   : "";
  const patientId = sessionStorage.getItem("patientId");
  const [loading, setLoading] = useState(false);
  const [chatData, setChatData] = useState([]);
  const [selectedChat, setSelectedChat] = useState(undefined);
  const [messagesLoading, setMessagesLoading] = useState(false);
  const [messages, setMessages] = useState([]);
  const [caseData, setCaseData] = useState();

  useEffect(() => {
    const resizeWindow = () => {
      setScreenWidth(window?.outerWidth);
      setChatView(window.outerWidth <= 767 ? "List" : "Both");
    };

    window?.addEventListener("resize", resizeWindow);

    resizeWindow();

    return () => {
      window.removeEventListener("resize", resizeWindow);
    };
  }, []);

  const getPatientChats = async () => {
    try {
      setLoading(true);

      const res = await getChats(email, patientId);

      if (res.status === 200 && res.data.status === 200) {
        setChatData(res.data.data);
        setSelectedChat(res?.data?.data[0]);
        setLoading(false);
      } else {
        toast.error(res.data.message || res.message);
        setChatData([]);
        setSelectedChat(undefined);
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.data.message || error.message);
      setChatData([]);
      setSelectedChat(undefined);
      setLoading(false);
    }
  };

  useEffect(() => {
    getPatientChats();
  }, []);

  const getChatMessages = async () => {
    try {
      setMessagesLoading(true);
      const res = await getMessagesByChat(email, selectedChat.chat_id);
      const res2 = await getCaseByCaseId(email, selectedChat.case_id);

      if (res2.status === 200 && res2.data.status === 200) {
        setCaseData(res2.data.data);
      } else {
        setCaseData([]);
      }
      if (res.status === 200 && res.data.status === 200) {
        setMessages(res.data.data);
        setMessagesLoading(false);
      } else {
        toast.success(res.data.message || res.message);
        setMessages([]);
        setMessagesLoading(false);
      }
    } catch (error) {
      toast.error(error.data.message || error.message);
      setMessagesLoading(false);
      return;
    }
  };

  useEffect(() => {
    if (selectedChat) {
      getChatMessages();
    }
  }, [selectedChat]);

  const handleUserClick = () => {
    if (chatView === "List") {
      setChatView("Messages");
    }
  };

  return (
    <div
      className="position-relative"
      style={{
        zIndex: "20",
        padding: "2px 15px 10px 15px",
      }}
    >
      <div
        className="row w-100 mx-auto flex-column align-items-center justify-content-start"
        style={{
          backgroundColor: "rgb(255, 255, 255)",
          padding: "13px 13px 20px 13px",
          borderRadius: "18px",
          gap: "15px",
          minHeight: "calc(100vh - 80px)",
        }}
      >
        {/* <div className="d-flex mt-2 justify-content-center text-center">
          <h4
            className="text-center"
            style={{
              color: HEADER_COLOR,
            }}
          >
            Discussions
          </h4>
        </div>
        <hr /> */}

        <div className="col-12 p-0">
          {loading && <Loader />}
          {!loading && chatData && chatData.length > 0 && (
            <div className="row">
              {chatView === "Messages" && (
                <div className="d-flex mb-2 justify-content-start">
                  <IoMdArrowRoundBack
                    onClick={() => setChatView("List")}
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                    }}
                  />
                </div>
              )}
              {chatView !== "Messages" && (
                <div
                  className="col-md-4 col-sm-12 col-12"
                  style={{
                    borderRight: "1px solid grey",
                    height: "80vh",
                    overflow: "scroll",
                  }}
                >
                  <div className="row">
                    {chatData?.map((chat, index) => {
                      return (
                        <div
                          className="col-12 pb-3 pt-3 card-hover-effect"
                          style={{
                            cursor: "pointer",
                            backgroundColor:
                              selectedChat?._id === chat._id
                                ? PRIMARY_COLOR
                                : "",
                            color:
                              selectedChat?._id === chat._id
                                ? TERTIARY_COLOR
                                : "",
                          }}
                          onClick={() => {
                            setSelectedChat(chat);
                            handleUserClick();
                          }}
                          key={index}
                        >
                          <div className="d-flex justify-content-between">
                            <div className="d-flex align-items-center">
                              <div
                                className=""
                                style={{
                                  width: "35px",
                                  height: "35px",
                                  borderRadius: "50%",
                                  backgroundImage:
                                    "linear-gradient(270deg, rgba(203,108,230,1) 0%, rgba(203,108,230,0.7) 80%, rgba(250,229,255,1) 100%)",
                                }}
                              >
                                <UserIcon
                                  style={{
                                    height: "100%",
                                    width: "100%",
                                  }}
                                />
                              </div>
                              <div className="d-flex flex-column ms-2">
                                <p
                                  style={{
                                    width: "120px",
                                    lineHeight: "20px",
                                  }}
                                  className="mb-0"
                                >
                                  {moment(chat?.chat_start_date).format(
                                    "DD-MMM-YY"
                                  )}
                                </p>

                                <small>
                                  {moment(chat.updated_at).format("hh:mm:ss A")}
                                </small>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              )}
              {(chatView === "Messages" || chatView === "Both") &&
                selectedChat &&
                chatData.length > 0 && (
                  <div className="col-md-8 col-sm-12 col-12">
                    <div
                      className="row w-100 mx-auto align-items-center justify-content-start card-hover-effect"
                      style={{
                        padding: "8px 4px 8px 10px",
                        backgroundColor: "rgb(203, 108, 230)",
                        borderRadius: "16px",
                        gap: "12px",
                        cursor: "pointer",
                      }}
                    >
                      <div className="col-auto p-0">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            height: "60px",
                            width: "60px",
                          }}
                        >
                          <img
                            className="w-100"
                            src={AlignerImage}
                            alt="aligner"
                            style={{}}
                          />
                        </div>
                      </div>
                      <div className="col p-0">
                        <div
                          className="d-flex flex-column justify-content-center"
                          style={{
                            fontSize: "16.5px",
                            color: "#ffffff",
                            gap: "3px",
                            lineHeight: "1",
                          }}
                        >
                          <div className="" style={{}}>
                            {caseData?.service && caseData?.service === "both"
                              ? "TP / FAB"
                              : caseData?.service.toUpperCase()}
                          </div>
                          <div
                            className=""
                            style={{
                              fontSize: "9.5px",
                              lineHeight: "1.25",
                            }}
                          >
                            Case Id: {caseData?.case_id}
                          </div>
                          <div
                            className=""
                            style={{
                              fontSize: "9.5px",
                              lineHeight: "1.25",
                            }}
                          >
                            Current Status: {caseData?.current_status}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* MESSAGES */}

                    <div className="row mx-1 my-3">
                      {messagesLoading && (
                        <div style={{ minHeight: "80vh" }}>
                          <Loader />
                        </div>
                      )}
                      {!messagesLoading &&
                        messages &&
                        messages.length === 0 && (
                          <div
                            className="row w-100 mx-auto flex-column align-items-center justify-content-start flex-nowrap"
                            style={{
                              gap: "20px",
                              minHeight: "calc(-248px + 100vh)",
                              maxHeight: "calc(-248px + 100vh)",
                              overflowY: "scroll",
                              scrollBehavior: "smooth",
                              scrollbarWidth: "none",
                              paddingBottom: "20px",
                            }}
                          >
                            <h6>No messages. </h6>
                          </div>
                        )}
                      {!messagesLoading && messages && messages.length > 0 && (
                        <div
                          className="row w-100 mx-auto flex-column align-items-center justify-content-start flex-nowrap"
                          style={{
                            gap: "20px",
                            minHeight: "calc(-248px + 100vh)",
                            maxHeight: "calc(-248px + 100vh)",
                            overflowY: "scroll",
                            scrollBehavior: "smooth",
                            scrollbarWidth: "none",
                            paddingBottom: "20px",
                          }}
                        >
                          {messages.map((message) => (
                            <>
                              {message.sender_id !== patientId ? (
                                <div
                                  className="row w-100 mx-auto align-items-start justify-content-start"
                                  style={{
                                    gap: "10px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        backgroundImage:
                                          "linear-gradient(270deg, rgba(203,108,230,1) 0%, rgba(203,108,230,0.7) 80%, rgba(250,229,255,1) 100%)",
                                      }}
                                    >
                                      <UserIcon
                                        style={{
                                          height: "100%",
                                          width: "100%",
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-start justify-content-start"
                                      style={{
                                        gap: "5px",
                                      }}
                                    >
                                      <div
                                        className="col-auto"
                                        style={{
                                          paddingInlineStart: "0",
                                          paddingInlineEnd: "45px",
                                        }}
                                      >
                                        <div
                                          className="text-start"
                                          style={{
                                            fontSize: "11px",
                                            color: PRIMARY_COLOR,
                                            backgroundColor: TERTIARY_COLOR,
                                            borderTopRightRadius: "15px",
                                            borderBottomRightRadius: "15px",
                                            borderTopLeftRadius: "15px",
                                            padding: "12px 10px 14px 11px",
                                            maxWidth:
                                              screenWidth >= 576
                                                ? "305px"
                                                : "100%",
                                          }}
                                        >
                                          {message?.message_content}
                                        </div>
                                      </div>
                                      <div className="col-auto p-0 d-flex">
                                        <div
                                          className="text-start"
                                          style={{
                                            fontSize: "9px",
                                            color: TEXT_COLOR,
                                            lineHeight: "1",
                                            marginRight: "2px",
                                          }}
                                        >
                                          {message?.sender_email?.split("@")[0]}
                                        </div>
                                        <div
                                          className="text-start"
                                          style={{
                                            fontSize: "9px",
                                            color: TEXT_COLOR,
                                            lineHeight: "1",
                                            marginRight: "2px",
                                          }}
                                        >
                                          |
                                        </div>
                                        <div
                                          className="text-start"
                                          style={{
                                            fontSize: "9px",
                                            color: TEXT_COLOR,
                                            lineHeight: "1",
                                            marginLeft: "2px",
                                          }}
                                        >
                                          {moment(message?.time).format(
                                            "DD-MMM-YY | hh:mm:ss A"
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div
                                  className="row w-100 mx-auto flex-row-reverse align-items-start justify-content-start"
                                  style={{
                                    gap: "10px",
                                  }}
                                >
                                  <div className="col-auto p-0">
                                    <div
                                      className=""
                                      style={{
                                        width: "35px",
                                        height: "35px",
                                        borderRadius: "50%",
                                        backgroundImage:
                                          "linear-gradient(270deg, rgba(203,108,230,1) 0%, rgba(203,108,230,0.7) 80%, rgba(250,229,255,1) 100%)",
                                      }}
                                    >
                                      <img
                                        className="w-100 h-100"
                                        src={ProfileImage2}
                                        alt="avatar1"
                                        style={{
                                          maxWidth: "100%",
                                          borderRadius: "50%",
                                          objectFit: "cover",
                                        }}
                                      />
                                    </div>
                                  </div>

                                  <div className="col p-0">
                                    <div
                                      className="row w-100 mx-auto flex-column align-items-end justify-content-start"
                                      style={{
                                        gap: "5px",
                                      }}
                                    >
                                      <div
                                        className="col-auto"
                                        style={{
                                          paddingInlineEnd: "0",
                                          paddingInlineStart: "45px",
                                        }}
                                      >
                                        <div
                                          className="text-end"
                                          style={{
                                            fontSize: "11px",
                                            color: TERTIARY_COLOR,
                                            backgroundColor: PRIMARY_COLOR,
                                            borderTopRightRadius: "15px",
                                            borderBottomLeftRadius: "15px",
                                            borderTopLeftRadius: "15px",
                                            padding: "12px 14px 14px 7px",
                                            maxWidth:
                                              screenWidth >= 576
                                                ? "305px"
                                                : "100%",
                                          }}
                                        >
                                          Lorem ipsum dolor sit amet,
                                          consectetur adipiscing elit.
                                        </div>
                                      </div>
                                      <div className="col-auto p-0">
                                        <div
                                          className="text-end"
                                          style={{
                                            fontSize: "9px",
                                            color: TEXT_COLOR,
                                            lineHeight: "1",
                                          }}
                                        >
                                          12:00 PM
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </>
                          ))}
                        </div>
                      )}
                      <div
                        className="row w-100 mx-auto align-items-center justify-content-center flex-nowrap"
                        style={{
                          backgroundColor: "#f6f8fe",
                          border: `1px solid ${PRIMARY_COLOR}`,
                          borderRadius: "20px",
                          padding: "5px 8px",
                          gap: "5px",
                        }}
                      >
                        <div className="col-auto p-0">
                          <button
                            className="btn upload-btn d-flex align-items-center justify-content-center"
                            style={{
                              width: "30px",
                              height: "30px",
                              backgroundColor: TERTIARY_COLOR,
                              borderRadius: "50%",
                              padding: "8px",
                              border: "none",
                              transition: "all 0.25s ease-in-out",
                            }}
                            disabled
                          >
                            <FiPaperclip
                              style={{
                                height: "100%",
                                width: "100%",
                                overflow: "visible",
                                color: HEADER_COLOR,
                              }}
                            />
                          </button>
                        </div>

                        <div className="col-auto p-0">
                          <div
                            className=""
                            style={{
                              borderLeft: `1px solid ${DESCRIPTION_COLOR}`,
                              height: "20px",
                            }}
                          ></div>
                        </div>

                        <div className="col p-0">
                          <input
                            className="w-100"
                            type="text"
                            placeholder="Message"
                            style={{
                              fontSize: "10px",
                              border: "none",
                              outline: "none",
                              background: "none",
                              padding: "5px",
                              lineHeight: "1",
                              color: TEXT_COLOR,
                            }}
                            disabled
                          />
                        </div>

                        <div className="col-auto p-0">
                          <button
                            className="btn send-btn d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: PRIMARY_COLOR,
                              padding: "7px",
                              borderRadius: "50%",
                              border: "none",
                            }}
                          >
                            <PiPaperPlaneTilt
                              style={{
                                height: "18px",
                                width: "18px",
                                overflow: "visible",
                                color: TERTIARY_COLOR,
                              }}
                            />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              {(chatView === "Messages" || chatView === "Both") &&
                !selectedChat &&
                chatData.length > 0 && (
                  <div className="col-md-8 col-sm-12 col-12">
                    {/* MESSAGES */}

                    <div className="row mx-1 my-3">
                      <div className="col-12 p-0">
                        <div
                          className="row w-100 mx-auto flex-column align-items-center justify-content-start flex-nowrap"
                          style={{
                            gap: "20px",
                            minHeight: "calc(-248px + 100vh)",
                            maxHeight: "calc(-248px + 100vh)",
                            overflowY: "scroll",
                            scrollBehavior: "smooth",
                            scrollbarWidth: "none",
                            paddingBottom: "20px",
                          }}
                        >
                          <h5>Select a chat to show messages!</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          )}
          {!loading && (!chatData || chatData.length === 0) && (
            <h6>No chats found!</h6>
          )}
        </div>
      </div>
    </div>
  );
};

export default DiscussionScreen;
